import axios from 'axios'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { CONSTANTS, FEATURES, URLS } from '../../factories'
import Token from '../../types/auth/token'
import { FeatureSwitchService } from '../../services'

export interface IAuthState {
    isProduction: boolean;
    isIdle: boolean;
    userAgent: string | null;
    token: Token | null;
    ipAddress: string | null;
    updateIsIdle: (val: boolean) => void;
}

@Module(
  {
    name: 'Auth',
    namespaced: true
  }
)
export default class Auth extends VuexModule implements IAuthState {
  // #region IsProduction

    isProduction = false;

    @Mutation
    private setIsProduction (val: boolean) {
      this.isProduction = val
    }

    @Action
    updateIsProduction () {
      this.setIsProduction(process.env.NODE_ENV === 'production')
    }

    // #endregion

    // #region isIdle

    isIdle = false;

    @Mutation
    private setIsIdle (val: boolean) {
      this.isIdle = val
    }

    @Action({ rawError: true })
    updateIsIdle (val: boolean) {
      this.setIsIdle(val)
    }

    // #endregion

    // #region User Agent

    userAgent: string | null = null;

    @Mutation
    private setUserAgent (val: string | null) {
      this.userAgent = val
    }

    @Action
    updateUserAgent () {
      const userAgent = navigator.userAgent
      this.setUserAgent(userAgent)
    }

    // #endregion

    // #region Token

    token: Token | null = null;

    @Mutation
    private setAuthToken (val: Token) {
      this.token = {...val,  'tokenUpdateTime': Math.floor(Date.now() / 1000) }
    }

    @Action
    async updateAuthToken () {
      const url = this.isProduction ? URLS.production.authApiUrl : URLS.replica.authApiUrl
      const auth = this.isProduction ? CONSTANTS.production.auth : CONSTANTS.replica.auth

      const response = await axios.post(url + '/v1/authorization/token', auth)

      if (response !== null) {
        this.setAuthToken(response.data)

        return true
      }

      return false
    }

    // #endregion

    // #region Device Info

    ipAddress: string | null = null;

    @Mutation
    private setIpAddress (val: string | null) {
      this.ipAddress = val
    }

    @Action
    async updateIpAddress () {
      const tokenString = 'Bearer ' + this.token!.authenticationToken
      const headersObj = { Authorization: tokenString }

      const delegateFn = async () => {
        const applicationApiFullUrl = this.isProduction ? URLS.production.applicationApiFullUrl : URLS.replica.applicationApiFullUrl

        const response = await axios({
          method: 'GET',
          url: applicationApiFullUrl + '/api/Client/GetIPAddress',
          headers: headersObj
        })

        if (response !== null) {
          this.setIpAddress(response.data)
        }
      }

			await delegateFn();
    }

  // #endregion
}
